<wsd-interaction-search
  [filter]="filter"
  (search)="search()">
</wsd-interaction-search>

<div *ngIf="interactions$ | async as data; else spinner">
  <div *ngFor="let interaction of data.content" [@FadeAnim]="'in'">
    <div class="m-b-30">
      <div class="m-b-5">
        <i *ngIf="interaction.important" class="fa fa-exclamation primary-color m-r-5"></i>
        <i *ngIf="interaction.confidential" class="fa fa-eye-slash primary-color m-r-5"></i>
        <a (click)="detail = interaction">{{ interaction.subject }}</a>
      </div>
      <div class="m-b-5">
        <strong>{{ interaction.person }}</strong> - <i class="fa fa-calendar"></i> {{ interaction.date | date: 'dd/MM/yyyy' }}
      </div>
      <div class="interaction-summary">
        <span [innerHTML]="cutSummaryText(interaction.summary)"></span>
        <div *ngIf="interaction.summary.length > 300" class="text-center">
          <a (click)="detail = interaction" style="font-size: 20px;"><i class="fa fa-caret-circle-down"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="interactions">
    <p-paginator
      *ngIf="data.totalElements > pageSize"
      [first]="first"
      [rows]="pageSize"
      [totalRecords]="data.totalElements"
      (onPageChange)="onPageChange($event)">
    </p-paginator>
  </div>
</div>

<wsd-interaction-dialog
  [interaction]="detail"
  (closed)="detail = null">
</wsd-interaction-dialog>

<ng-template #spinner>
  <div class="text-center vertical-margin">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</ng-template>
